export default __webpack_public_path__ + "static/AppMoneyWalkie4-0d41119943f1231c1ee71d6670eb8401.png";